module.exports = __webpack_public_path__ + "media/images/common/tw-e0391bd118ce1f51d0830598e60fbbb0.svg";